/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import {
    bool, string, func, object,
} from 'prop-types';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'inline-flex',
        justifyContent: 'flex-start',
        alignItems: 'center',

        width: '100%',
        height: '60px',
        textTransform: 'none',
        padding: '0',

        border: '2px solid #EEEEEE',
        '&:hover': {
            background: 'none',
            border: `2px solid ${theme.palette.colorPrimary}`,
        },

        '&--selected': {
            border: `2px solid ${theme.palette.colorPrimary}`,
        },

        '&--disabled': {
            filter: 'grayscale(1)',
            textDecoration: 'line-through',
            '&:hover': {
                filter: 'grayscale(1)',
                textDecoration: 'line-through',
                border: '2px solid #EEEEEE',
                cursor: 'unset',
            },
        },
    },

    containerSelectedCheckbox: {
        position: 'absolute',
        right: '0px',
        bottom: '0px',

        height: '20px',
        width: '20px',
        backgroundColor: theme.palette.colorPrimary,
    },

    checkRoot: {
        color: 'white',
        position: 'absolute',
        top: '-3px',
        left: '3px',
        width: '0.6em',
    },

    imageContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'center',

        height: '56px',
        width: '47px',
        backgroundColor: 'white',
    },

    thumbnail: {
        // position: 'absolute',
        // left: '0',
        // top: '0',

        maxHeight: '45px',
        width: 'auto',

        // display: 'block',
        // width: '100%',
        // height: 'auto',
    },

    textContainer: {
        width: 'calc(100% - 47px)',
        marginLeft: '5px',
    },

    titleContainer: {
        width: '100%',

        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',

        fontSize: '.9em',
        whiteSpace: 'nowrap',

        '&--center': {
            justifyContent: 'center',
        },
    },

    titleText: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },

    price: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',

        fontSize: '.85em',
        color: '#727171',

        '&--center': {
            justifyContent: 'center',
        },
    },

    disabledFilter: {
        height: '100%',
        width: '100%',
        position: 'absolute',
        backgroundColor: '#8080805e',
        opacity: '0.4',
    },
}));

const OptionButton = (props) => {
    const {
        title,
        styleOverride,
        selected,
        handleOnClick,
        enabled,
        thumbnailLink,
        hardcodedPrice,
    } = props;

    const classes = useStyles();

    let buttonStyle = `${classes.container}`;

    if (selected) {
        buttonStyle += ` ${classes.container}--selected`;
    }

    if (!enabled) {
        buttonStyle += ` ${classes.container}--disabled`;
    }

    let titleStyle = `${classes.titleContainer}`;
    let priceStyle = `${classes.price}`;

    if (!thumbnailLink) {
        titleStyle += ` ${classes.titleContainer}--center`;
        priceStyle += ` ${classes.price}--center`;
    }

    return (
        <Button
            className={buttonStyle}
            style={styleOverride}
            disableTouchRipple={!enabled}
            onClick={(e) => {
                if (!enabled) {
                    return;
                }
                handleOnClick(e);
            }}
        >
            {thumbnailLink
                && (
                    <div className={classes.imageContainer}>
                        {!enabled
                            && <div className={classes.disabledFilter} />}
                        <img
                            src={`${thumbnailLink}`}
                            alt={title}
                            className={classes.thumbnail}
                        />
                    </div>
                )}

            <div className={classes.textContainer}>
                <div className={titleStyle}>
                    <span className={classes.titleText}>
                        {title}
                    </span>
                </div>
                <div className={priceStyle}>
                    {hardcodedPrice}
                </div>
            </div>
            {selected && (
                <div
                    className={classes.containerSelectedCheckbox}
                >
                    <CheckIcon
                        classes={{
                            root: classes.checkRoot,
                        }}
                    />
                </div>
            )}
        </Button>
    );
};

OptionButton.propTypes = {
    thumbnailLink: string.isRequired,
    hardcodedPrice: string.isRequired,
    title: string.isRequired,
    selected: bool.isRequired,
    handleOnClick: func.isRequired,
    enabled: bool.isRequired,
    styleOverride: object,
};

OptionButton.defaultProps = {
    styleOverride: {},
};

export default OptionButton;
